import { useState } from 'react';
import { faqList } from '@/mocks/site';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 px-3 py-1.5 text-xs font-label text-foreground-600">
              <i className="ri-question-line text-primary-400" />
              常见问题
            </span>
            <h2 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              关于更新的那点事
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              更新频率、热度数值、核实标记、投稿方式，读者最常问的问题都在这里。
              如果还有疑问，可以直接在「关于我们」页面联系我们。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-lg border transition-colors ${
                      isOpen ? 'border-primary-400/60 bg-background-50' : 'border-background-200 bg-background-50/60'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3 text-sm font-label text-foreground-950 md:text-base">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-200 text-xs text-primary-400">
                          Q
                        </span>
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                          isOpen ? 'rotate-180 text-primary-400' : ''
                        }`}
                      >
                        {isOpen ? 'ri-subtract-line' : 'ri-add-line'}
                      </i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}